import type { FC } from 'react'

import { Icon, type IconProps } from '@circlefin/components/lib/Icon'

interface DescriptionItemProps {
  /**
   * Icon that should be displayed.
   */
  icon: IconProps['name']
  /**
   * Title of the item.
   */
  title: string
  /**
   * Description of the item.
   */
  description: string
}

export const DescriptionItem: FC<DescriptionItemProps> = ({
  icon,
  title,
  description,
}) => {
  return (
    <div>
      <div className="flex items-start justify-start">
        <div className="w-12 shrink-0">
          <Icon className="mt-1 text-interactive" name={icon} size={25} />
        </div>
        <div className="type-header-md">{title}</div>
      </div>
      <div className="ml-12 mt-2 type-body-base">{description}</div>
    </div>
  )
}
